import useResponsiveValue from '@beatgig/hooks/use-responsive-value'

export function useProductsDropdown() {
  const isDropdownInHeader = useResponsiveValue([false, false, false, true])

  return {
    isDropdownInHeader,
  }
}
